// 3rd party imports
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';

// bernie
import { ContextStore } from 'bernie-core';

// shared-ui
import { ILocalization, LocalizedText, withLocalization } from '@shared-ui/localization-context';

// mobx
import { Legal, Program } from 'src/models';
import { LegalStore, PzCampaignStore, PzStore } from '../../stores';

// ui
import { UitkHeading } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';

import { RouteComponentProps } from 'react-router';

export interface EntityTermsAndConditionsProps extends RouteComponentProps {
  program?: Program;
  context?: ContextStore;
  l10n?: ILocalization;
  legal?: LegalStore;
  pzCampaignStore?: PzCampaignStore;
}

export interface EntityTermsAndConditionsState {
  legal?: Legal;
  terms;
}

@withLocalization
@inject('context', 'legal', 'pzCampaignStore')
@observer
export class EntityTermsAndConditions extends React.Component<
  EntityTermsAndConditionsProps,
  EntityTermsAndConditionsState
> {
  constructor(props) {
    super(props);

    const siteId = this.props.context.site.id;

    this.state = {
      legal: this.props.legal.getConfig(siteId),
      terms: [],
    };
  }

  public async componentDidMount() {
    const pzLocale = this.props.program.pzLocale || this.props.program.locale.toLowerCase();

    await this.props.pzCampaignStore.fetchCampaign(this.props.program.name, this.props.context.locale, pzLocale);

    const entityTc = this.props.pzCampaignStore.campaignTerms;
    this.setState({ terms: entityTc });
  }

  public render() {
    const htmlPart = this.state.terms;

    return (
      <UitkSpacing className="container--small" padding={{ block: 'twelve' }}>
        <main>
          <UitkHeading tag="h1" size={3}>
            <LocalizedText message="pz.signup.form.label.program_terms" data={[this.props.program.title]} />
          </UitkHeading>
          <UitkSpacing margin={{ block: 'three' }}>
            <div dangerouslySetInnerHTML={{ __html: htmlPart }} />
          </UitkSpacing>
        </main>
      </UitkSpacing>
    );
  }
}

export const TcWithRouter = withRouter(EntityTermsAndConditions);
